import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Loader2 } from 'lucide-react';

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const GOOGLE_OAUTH_URL = 'https://auth.emergentagent.com';

export function GoogleOAuthButton({ label = 'Continue with Google' }) {
  const redirectUrl = `${window.location.origin}/auth/callback`;
  return (
    <a
      data-testid="google-oauth-btn"
      href={`${GOOGLE_OAUTH_URL}/?redirect=${encodeURIComponent(redirectUrl)}`}
      className="w-full flex items-center justify-center gap-3 bg-white border-2 border-slate-200 text-slate-700 font-semibold rounded-none px-8 py-3 transition-all hover:bg-slate-50 hover:border-slate-300"
    >
      <svg width="20" height="20" viewBox="0 0 256 262"><path fill="#4285F4" d="M255.878 133.451c0-10.734-.871-18.567-2.756-26.69H130.55v48.448h71.947c-1.45 12.04-9.283 30.172-26.69 42.356l-.244 1.622 38.755 30.023 2.685.268c24.659-22.774 38.875-56.282 38.875-96.027"/><path fill="#34A853" d="M130.55 261.1c35.248 0 64.839-11.605 86.453-31.622l-41.196-31.913c-11.024 7.688-25.82 13.055-45.257 13.055-34.523 0-63.824-22.773-74.269-54.25l-1.531.13-40.298 31.187-.527 1.465C35.393 231.798 79.49 261.1 130.55 261.1"/><path fill="#FBBC05" d="M56.281 156.37c-2.756-8.123-4.351-16.827-4.351-25.82 0-8.994 1.595-17.697 4.206-25.82l-.073-1.73L15.26 71.312l-1.335.635C5.077 89.644 0 109.517 0 130.55s5.077 40.905 13.925 58.602l42.356-32.782"/><path fill="#EB4335" d="M130.55 50.479c24.514 0 41.05 10.589 50.479 19.438l36.844-35.974C195.245 12.91 165.798 0 130.55 0 79.49 0 35.393 29.301 13.925 71.947l42.211 32.783c10.59-31.477 39.891-54.251 74.414-54.251"/></svg>
      {label}
    </a>
  );
}

export function AuthDivider() {
  return (
    <div className="relative my-6">
      <div className="absolute inset-0 flex items-center"><div className="w-full border-t border-slate-200" /></div>
      <div className="relative flex justify-center"><span className="bg-white px-3 text-sm text-slate-500">or</span></div>
    </div>
  );
}

export function AuthFormField({ id, label, type = 'text', value, onChange, placeholder, testId, ...rest }) {
  return (
    <div className="space-y-2">
      <Label htmlFor={id} className="text-sm font-semibold text-slate-900">{label}</Label>
      <Input
        id={id}
        data-testid={testId}
        type={type}
        value={value}
        onChange={onChange}
        className="rounded-none border-b-2 border-slate-200 bg-transparent focus:border-[#FB923C] focus:ring-0 px-0 py-3 text-lg transition-colors"
        placeholder={placeholder}
        {...rest}
      />
    </div>
  );
}

export function AuthSubmitButton({ loading, loadingText, text, testId }) {
  return (
    <Button
      data-testid={testId}
      type="submit"
      disabled={loading}
      className="w-full bg-[#FB923C] hover:bg-orange-300 text-slate-900 font-bold rounded-none px-8 py-3 transition-all hover:-translate-y-1 shadow-[4px_4px_0px_#0F172A] hover:shadow-[6px_6px_0px_#0F172A] disabled:opacity-50 disabled:cursor-not-allowed"
    >
      {loading ? (
        <><Loader2 className="w-4 h-4 animate-spin mr-2" /> {loadingText}</>
      ) : (
        text
      )}
    </Button>
  );
}

export function AuthError({ error, testId }) {
  if (!error) return null;
  return (
    <div data-testid={testId} className="bg-red-50 border border-red-200 text-red-800 px-4 py-3 text-sm">
      {error}
    </div>
  );
}
